module.exports = new __parcel__URL__("periscope-page-stable.tpl.d010a24b.svg").toString();